/* eslint-disable max-len */
const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;

  const background = '#383C47';

  return {
    input: {
      '&.ant-input, & .ant-input, &.ant-input-affix-wrapper': {
        color: 'white',
        borderRadius: '10px',
        borderColor: 'transparent',
        background,
      },
      '& .ant-input': {
        color: 'white',
        background,
      },
      '&.ant-input-affix-wrapper-status-error:not(.ant-input-affix-wrapper-disabled):not(.ant-input-affix-wrapper-borderless).ant-input-affix-wrapper, &.ant-input-status-error:not(.ant-input-disabled):not(.ant-input-borderless).ant-input':
        {
          background,
        },
      '&.ant-input-affix-wrapper>.ant-input:not(textarea)': {
        background: 'transparent',
        boxShadow: 'none',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
